import React from 'react';
import dynamic from 'next/dynamic';
const SurveyQuickForm = dynamic(
  import('../SurveyQuickForm/SurveyQuickForm.jsx')
);

export default function FormWidget({
  xuid,
  user,
  useQuery,
  formQuery,
  addUserEvent,
  addFormAnswer,
  submitFormAnswer,
  quickFormTrackingCodes
}) {
  const { data: { form = {} } = {}, loading } = useQuery(formQuery, {
    variables: { xuid }
  });

  if (loading) return null;

  return (
    <div className="form-widget">
      <SurveyQuickForm
        user={user}
        item={form}
        addUserEvent={addUserEvent}
        addFormAnswer={addFormAnswer}
        submitFormAnswer={submitFormAnswer}
        quickFormTrackingCodes={quickFormTrackingCodes}
      />
    </div>
  );
}
